import QuickReportTable from './QuickReportTable';

export default QuickReportTable;
